module.exports = __webpack_public_path__ + "img/svdpwa.73d7008.jpg";